import ExamNoteApi from '@/apis/business/teacher/exam-note-api'
import { HttpStatusCode } from '@/common/constant'

export default {
  namespaced: true,

  state: {
    noteList: []
  },

  getters: {},

  mutations: {
    setNoteList (state, noteList) {
      state.noteList = noteList
    }
  },

  actions: {
    updateNote (context, params) {
      return new Promise((resolve, reject) => {
        ExamNoteApi.postAsync('/update-note', params.examNoteParams, { params: { scope: params.scope } }).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },

    getNoteList (context, params) {
      return new Promise((resolve, reject) => {
        ExamNoteApi.getAsync('/get-note', { params }).then(res => {
          if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
            context.commit('setNoteList', res.Data)
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}
